const logItemStatusDefault = 'draft';
const logItemStatusOptions = [
  {
    value: 'draft',
    label: 'Draft',
    icon: 'draft',
    iconLibrary: 'material',
    description: 'Only visible to the organizers',
  },
  {
    value: 'published',
    label: 'Published',
    icon: 'campaign',
    iconLibrary: 'material',
    description: 'Published and visible to the selected audience',
  },
  {
    value: 'archived',
    label: 'Archived',
    icon: 'inventory_2',
    iconLibrary: 'material',
    description: 'Archived and visible only to organizers',
  },
];
const logItemStatusMap = Object.fromEntries(logItemStatusOptions.map((o) => [o.value, o]));


const logItemVisibilityDefault = 'supporters';
const logItemVisibilityOptions_guilds = [
  { 
    value: 'public',
    label: 'Public',
    icon: 'public',
    iconLibrary: 'material',
    description: 'Visible on the public internet',
  },
  {
    value: 'network',
    label: 'Network',
    icon: 'q1-logo',
    iconLibrary: 'q1',
    description: 'Visible to members of the q1 Network',
  },
  {
    value: 'supporters',
    label: 'Supporters',
    icon: 'diversity_3',
    iconLibrary: 'material',
    description: 'Visible to members of the guild (does not include followers)',
  },
  {
    value: 'contributors',
    label: 'Contributors',
    icon: 'communities',
    iconLibrary: 'material',
    description: 'Visible to contributors & organizers'
  },
];
const logItemVisibilityMap_guilds = Object.fromEntries(
  logItemVisibilityOptions_guilds.map((o) => [o.value, o])
);
const logItemVisibilityOptions_projects = [
  { 
    value: 'public',
    label: 'Public',
    icon: 'public',
    iconLibrary: 'material',
    description: 'Visible on the public internet',
  },
  {
    value: 'network',
    label: 'Network',
    icon: 'q1-logo',
    iconLibrary: 'q1',
    description: 'Visible to members of the q1 Network',
  },
  {
    value: 'project-network',
    label: 'Project Network',
    icon: 'hub',
    iconLibrary: 'material',
    description: 'Visible to members & followers of the project, plus members of connected guilds',
  },
  {
    value: 'supporters',
    label: 'Supporters',
    icon: 'diversity_3',
    iconLibrary: 'material',
    description: 'Visible to members of the project (does not include followers)',
  },
  {
    value: 'contributors',
    label: 'Contributors',
    icon: 'communities',
    iconLibrary: 'material',
    description: 'Visible to contributors & organizers'
  },
];
const logItemVisibilityMap_projects = Object.fromEntries(
  logItemVisibilityOptions_projects.map((o) => [o.value, o])
);
const logItemVisibilityMap = {
  guilds: logItemVisibilityMap_guilds,
  projects: logItemVisibilityMap_projects,
};

/** These are the display details of a log item if NOT at published status. */
const nonPublishedVisibility = {
  value: 'non-published',
  label: 'Non-Published',
  icon: 'visibility_off',
  iconLibrary: 'material',
  description: 'Only visible to organizers'
};

export {
  logItemStatusDefault,
  logItemStatusOptions,
  logItemStatusMap,

  logItemVisibilityDefault,
  logItemVisibilityOptions_guilds,
  logItemVisibilityMap_guilds,
  logItemVisibilityOptions_projects,
  logItemVisibilityMap_projects,
  logItemVisibilityMap,

  nonPublishedVisibility,
};
